import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';
import { SimpleErrorResponse } from '@/models/Error';

export type Branches = {
  branches: string[];
};

type BranchesParams = {
  /** Case-insensitive substring the returned branch names contain. */
  q?: string;
  /**
   * The most branches to return, clamped to 1000 by the endpoint. Required because without it every
   * branch comes back, which for some repositories is enough to crash the tab.
   */
  limit: number;
};

const useBranches = (
  appSlug: string,
  params: BranchesParams,
  opts?: UseMonolithApiQueryOptions<Branches, SimpleErrorResponse>,
) => {
  return useMonolithApiQuery<Branches, SimpleErrorResponse>(
    ['git-branches', appSlug, params],
    `/app/${appSlug}/git-branches`,
    { ...opts, requestConfig: { ...opts?.requestConfig, params } },
  );
};

export default useBranches;
